function charToCnpjDvValue(char: string): number {
  const code = char.charCodeAt(0);

  // Regra oficial:
  // valor para cálculo do DV = ASCII - 48
  // '0'..'9' => 0..9
  // 'A'..'Z' => 17..42
  const value = code - 48;

  const isDigit = code >= 48 && code <= 57;
  const isUpperLetter = code >= 65 && code <= 90;

  if (!isDigit && !isUpperLetter) {
    throw new Error(`Caractere inválido no CNPJ: "${char}"`);
  }

  return value;
}

function calculateCnpjDv(base: string): number {
  let sum = 0;
  let weight = 2;

  // Pesos de 2 a 9 da direita para a esquerda
  for (let i = base.length - 1; i >= 0; i--) {
    sum += charToCnpjDvValue(base[i]) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }

  const remainder = sum % 11;

  // Se resto for 0 ou 1 => DV = 0
  return remainder < 2 ? 0 : 11 - remainder;
}

export function validateCnpj(cnpj: string): boolean {
  if (!cnpj) return false;

  // Remove pontuação e normaliza para maiúsculas
  const normalized = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  // CNPJ alfanumérico: 12 chars base + 2 DVs numéricos
  if (!/^[A-Z0-9]{12}\d{2}$/.test(normalized)) {
    return false;
  }

  // Bloqueia sequência de mesmo caractere repetido 14x
  // (proteção útil contra lixo tipo AAAAAAAAAAAAAA / 11111111111111)
  if (/^(.)\1{13}$/.test(normalized)) {
    return false;
  }

  const base12 = normalized.slice(0, 12);
  const dvInformado = normalized.slice(12);

  const dv1 = calculateCnpjDv(base12);
  const dv2 = calculateCnpjDv(base12 + String(dv1));

  return dvInformado === `${dv1}${dv2}`;
}
